import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { loadIpmaYcMembershipStatisticsCreator } from 'store/actionsCreators';
import MembershipStatisticsTable from './MembershipStatisticsTable';

/** Welcome letters and membership badges issued, per Young Crew. */
const YcMembershipStatistics = ({ items, loading, loadStatistics }) => {
  const { t } = useTranslation();

  useEffect(() => {
    loadStatistics();
  }, []);

  return (
    <MembershipStatisticsTable
      items={items}
      loading={loading}
      organisationHeading={t('page.ipma.membershipStatistics.youngCrew')}
    />
  );
};

YcMembershipStatistics.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  loadStatistics: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, loading }) => ({
  items: ipma.people.ycMembershipStatistics.items,
  loading: !!loading.filter((item) => item.type === 'IPMA').length,
});

const mapDispatchToProps = (dispatch) => ({
  loadStatistics: () => dispatch(loadIpmaYcMembershipStatisticsCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(YcMembershipStatistics);
